
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 53 50","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.052.769H6.056v28.38a2.722 2.722 0 002.72 2.721h35.556a2.722 2.722 0 002.72-2.721V.769z","fill-opacity":".25"}}),_c('path',{attrs:{"d":"M25.785 32.638H8.776a3.49 3.49 0 01-3.488-3.489V1.537H.932V0h51.244v1.537h-4.355v27.612a3.49 3.49 0 01-3.489 3.489H27.323v5.446l9.839 9.804-1.091 1.087-8.748-8.717V50h-1.538v-9.736l-8.711 8.711-1.087-1.087 9.798-9.799v-5.451zM46.283 1.537v27.612a1.953 1.953 0 01-1.951 1.952H8.776a1.953 1.953 0 01-1.951-1.952V1.537h39.458zm-9.992 22.841v-7.175h-3.075v7.175h3.075zm-16.399 0V14.175h-3.074v10.203h3.074zm5.125-15.374v15.374h3.074V9.004h-3.074z"}})])
          )
        }
      }
    